import React from 'react';
import {
  string, arrayOf, element, oneOfType, func
} from 'prop-types';

export const QuickViewMore = ({
  title,
  children,
  onClick
}) => (
  <div
    onClick={onClick}
    role="link"
    tabIndex="0"
    className="quickview-details__other-more"
    data-testid="quickview-more-link"
  >
    { title ? (
      <h3>{title}</h3>
    ) : (
      children
    ) }
    <img src="https://assets.homedepot-static.com/images/v1/caret-orange.svg" alt="More" />
  </div>
);

QuickViewMore.propTypes = {
  title: string,
  children: oneOfType([
    element,
    arrayOf(element)
  ]),
  onClick: func.isRequired
};

QuickViewMore.defaultProps = {
  title: '',
  children: null
};